export default {
    login: process.env.VUE_APP_BACKEND_URL + '/api/auth/login',
    check_auth: process.env.VUE_APP_BACKEND_URL + '/api/auth/check',
    logout: process.env.VUE_APP_BACKEND_URL + '/api/auth/logout',
    impersonate_student_from_contact_person: process.env.VUE_APP_BACKEND_URL + '/api/auth/impersonate_student_from_contact_person',
    impersonate_rollback: process.env.VUE_APP_BACKEND_URL + '/api/auth/impersonate_rollback',

    app_global_settings_item: process.env.VUE_APP_BACKEND_URL + '/api/app_global_settings/{id}',
    app_global_settings_list: process.env.VUE_APP_BACKEND_URL + '/api/app_global_settings',
    app_global_settings_can_student_register: process.env.VUE_APP_BACKEND_URL + '/api/app_global_settings/can_student_register',

    admin_dashboard: process.env.VUE_APP_BACKEND_URL + '/api/admin/dashboard',

    student_list: process.env.VUE_APP_BACKEND_URL + '/api/students',
    student_item: process.env.VUE_APP_BACKEND_URL + '/api/students/{id}',
    student_public_register: process.env.VUE_APP_BACKEND_URL + '/api/students/public_register',
    student_with_valid_insurance: process.env.VUE_APP_BACKEND_URL + '/api/students/with_valid_insurance',
    student_password_reset: process.env.VUE_APP_BACKEND_URL + '/api/students/{email}/password_reset',
    student_check_password_reset_token: process.env.VUE_APP_BACKEND_URL + '/api/students/{passwordResetToken}/check_password_reset_token',
    student_update_password: process.env.VUE_APP_BACKEND_URL + '/api/students/{passwordResetToken}/update_password',
    student_gala_course_registered_list: process.env.VUE_APP_BACKEND_URL + '/api/students/{studentId}/gala/{galaId}/courses_registered',
    student_gala_course_registered_list_for_logged_student: process.env.VUE_APP_BACKEND_URL + '/api/students/gala/{galaId}/courses_registered',
    student_my_courses: process.env.VUE_APP_BACKEND_URL + '/api/students/my_courses',
    student_my_galas: process.env.VUE_APP_BACKEND_URL + '/api/students/my_galas',
    student_gala_list_based_on_course_registrations: process.env.VUE_APP_BACKEND_URL + '/api/galas/student_gala_list_based_on_course_registrations',
    student_dashboard_agenda: process.env.VUE_APP_BACKEND_URL + '/api/student/dashboard/agenda',
    student_dashboard_summary: process.env.VUE_APP_BACKEND_URL + '/api/student/dashboard/summary',
    student_register_eligibility: process.env.VUE_APP_BACKEND_URL + '/api/student_register/eligibility',
    student_register_courses: process.env.VUE_APP_BACKEND_URL + '/api/student_register/courses',
    student_register_payment: process.env.VUE_APP_BACKEND_URL + '/api/payments/student_register',
    student_register_payment_cancel: process.env.VUE_APP_BACKEND_URL + '/api/payments/student_register/cancel',
    student_quota_summary: process.env.VUE_APP_BACKEND_URL + '/api/students/{id}/quota_summary',

    address_item: process.env.VUE_APP_BACKEND_URL + '/api/addresses/{id}',
    address_list: process.env.VUE_APP_BACKEND_URL + '/api/addresses',

    teacher_list: process.env.VUE_APP_BACKEND_URL + '/api/teachers',
    teacher_item: process.env.VUE_APP_BACKEND_URL + '/api/teachers/{id}',
    teacher_password_reset: process.env.VUE_APP_BACKEND_URL + '/api/teachers/{email}/password_reset',
    teacher_check_password_reset_token: process.env.VUE_APP_BACKEND_URL + '/api/teachers/{passwordResetToken}/check_password_reset_token',
    teacher_update_password: process.env.VUE_APP_BACKEND_URL + '/api/teachers/{passwordResetToken}/update_password',

    insurance_list: process.env.VUE_APP_BACKEND_URL + '/api/insurances',
    insurance_item: process.env.VUE_APP_BACKEND_URL + '/api/insurances/{id}',
    insurance_insurance_subscriptions_list: process.env.VUE_APP_BACKEND_URL + '/api/insurances/{id}/insurance_subscriptions',

    medical_certificate_list: process.env.VUE_APP_BACKEND_URL + '/api/medical_certificates',
    medical_certificate_item: process.env.VUE_APP_BACKEND_URL + '/api/medical_certificates/{id}',

    card_type_list: process.env.VUE_APP_BACKEND_URL + '/api/card_types',
    card_type_item: process.env.VUE_APP_BACKEND_URL + '/api/card_types/{id}',

    card_list: process.env.VUE_APP_BACKEND_URL + '/api/cards',
    card_item: process.env.VUE_APP_BACKEND_URL + '/api/cards/{id}',

    course_list: process.env.VUE_APP_BACKEND_URL + '/api/courses',
    course_register_list: process.env.VUE_APP_BACKEND_URL + '/api/courses_register',
    course_item: process.env.VUE_APP_BACKEND_URL + '/api/courses/{id}',
    course_list_public: process.env.VUE_APP_BACKEND_URL + '/api/courses/public',
    course_days_list: process.env.VUE_APP_BACKEND_URL + '/api/courses/{id}/get_all_course_days',

    gala_list: process.env.VUE_APP_BACKEND_URL + '/api/galas',
    gala_item: process.env.VUE_APP_BACKEND_URL + '/api/galas/{id}',
    gala_course_list: process.env.VUE_APP_BACKEND_URL + '/api/galas/{id}/courses',
    gala_course_student_list: process.env.VUE_APP_BACKEND_URL + '/api/galas/{id}/courses_students',

    lesson_list: process.env.VUE_APP_BACKEND_URL + '/api/lessons',
    lesson_item: process.env.VUE_APP_BACKEND_URL + '/api/lessons/{id}',
    lesson_generate_month: process.env.VUE_APP_BACKEND_URL + '/api/lessons/month/generate',

    workshop_list: process.env.VUE_APP_BACKEND_URL + '/api/workshops',
    workshop_list_public: process.env.VUE_APP_BACKEND_URL + '/api/workshops/public',
    workshop_item: process.env.VUE_APP_BACKEND_URL + '/api/workshops/{id}',
    workshop_days_list: process.env.VUE_APP_BACKEND_URL + '/api/workshops/{id}/get_all_workshop_days',

    workshop_day_list: process.env.VUE_APP_BACKEND_URL + '/api/workshop_days',
    workshop_day_item: process.env.VUE_APP_BACKEND_URL + '/api/workshop_days/{id}',

    holidays_list: process.env.VUE_APP_BACKEND_URL + '/api/holidays',
    holidays_item: process.env.VUE_APP_BACKEND_URL + '/api/holidays/{id}',

    contact_person_list: process.env.VUE_APP_BACKEND_URL + '/api/contact_people',
    contact_person_item: process.env.VUE_APP_BACKEND_URL + '/api/contact_people/{id}',
    contact_person_password_reset: process.env.VUE_APP_BACKEND_URL + '/api/contact_people/{email}/password_reset',
    contact_person_check_password_reset_token: process.env.VUE_APP_BACKEND_URL + '/api/contact_people/{passwordResetToken}/check_password_reset_token',
    contact_person_update_password: process.env.VUE_APP_BACKEND_URL + '/api/contact_people/{passwordResetToken}/update_password',
    contact_person_managed_students: process.env.VUE_APP_BACKEND_URL + '/api/contact_people/student/my_managed_students',

    course_registration_item: process.env.VUE_APP_BACKEND_URL + '/api/course_registrations/{id}',
    course_registration_list: process.env.VUE_APP_BACKEND_URL + '/api/course_registrations',

    workshop_registration_item: process.env.VUE_APP_BACKEND_URL + '/api/workshop_registrations/{id}',
    workshop_registration_list: process.env.VUE_APP_BACKEND_URL + '/api/workshop_registrations',

    insurance_subscription_item: process.env.VUE_APP_BACKEND_URL + '/api/insurance_subscriptions/{id}',
    insurance_subscription_list: process.env.VUE_APP_BACKEND_URL + '/api/insurance_subscriptions',

    workshop_attendance_item: process.env.VUE_APP_BACKEND_URL + '/api/workshop_attendances/{id}',
    workshop_attendance_list: process.env.VUE_APP_BACKEND_URL + '/api/workshop_attendances',

    teacher_contract_item: process.env.VUE_APP_BACKEND_URL + '/api/teacher_contracts/{id}',
    teacher_contract_list: process.env.VUE_APP_BACKEND_URL + '/api/teacher_contracts',

    admin_item: process.env.VUE_APP_BACKEND_URL + '/api/admins/{id}',
    admin_list: process.env.VUE_APP_BACKEND_URL + '/api/admins',

    payment_item: process.env.VUE_APP_BACKEND_URL + '/api/payments/{id}',
    payment_list: process.env.VUE_APP_BACKEND_URL + '/api/payments',
    payment_create_witch_checkout: process.env.VUE_APP_BACKEND_URL + '/api/payments/create_with_checkout',
    registration_fee_credit_list: process.env.VUE_APP_BACKEND_URL + '/api/registration_fee_credits',
    registration_fee_credit_resolve: process.env.VUE_APP_BACKEND_URL + '/api/registration_fee_credits/{id}/resolve',

    gala_registration_item: process.env.VUE_APP_BACKEND_URL + '/api/gala_registrations/{id}',
    gala_registration_list: process.env.VUE_APP_BACKEND_URL + '/api/gala_registrations',
    gala_registration_list_details: process.env.VUE_APP_BACKEND_URL + '/api/gala_registrations/details',
    gala_registration_student_register: process.env.VUE_APP_BACKEND_URL + '/api/gala_registrations/student_register',

    clothing_size_item: process.env.VUE_APP_BACKEND_URL + '/api/clothing_sizes/{id}',
    clothing_size_list: process.env.VUE_APP_BACKEND_URL + '/api/clothing_sizes',
    clothing_size_list_for_student: process.env.VUE_APP_BACKEND_URL + '/api/clothing_sizes/list_for_student',

    gala_show_item: process.env.VUE_APP_BACKEND_URL + '/api/gala_shows/{id}',
    gala_show_list: process.env.VUE_APP_BACKEND_URL + '/api/gala_shows',

    uploadable_document_item: process.env.VUE_APP_BACKEND_URL + '/api/uploadable_documents/{id}',
    uploadable_document_list: process.env.VUE_APP_BACKEND_URL + '/api/uploadable_documents',

    report_teacher_hours: process.env.VUE_APP_BACKEND_URL + '/api/reports/teacher_hours',
    report_course_registrations: process.env.VUE_APP_BACKEND_URL + '/api/reports/course_registrations',
    report_student_courses: process.env.VUE_APP_BACKEND_URL + '/api/reports/student_courses',
    report_gala_registrations: process.env.VUE_APP_BACKEND_URL + '/api/reports/gala_registrations',
    report_teacher_courses: process.env.VUE_APP_BACKEND_URL + '/api/reports/teacher_courses',
    report_insurance: process.env.VUE_APP_BACKEND_URL + '/api/reports/insurance_status',
}
